import React from 'react';
import { formatCurrency, formatPhoneNumber } from 'utils/utils.js';
import { useSelector } from 'react-redux';
import { getHomeValForm } from 'store';

const PropDetailsWithVal = (props) => {
  const { fields = {}, intention } = props;
  const { fields: homeValFields } = useSelector(getHomeValForm);
  const { propertyPhoto, street, sqft, beds, baths, priceAverage } = fields;
  const { kvCoreAgentInfo, kvCorePlatformName } = homeValFields;

  const propSpecs = [beds + ' bd', baths + ' ba', sqft + ' sqft'];
  const topClass = intention === 'Curious' ? '' : 'top';

  return (
    <div className="prop-details-wrapper">
      <div className={`prop-details results ${topClass}`}>
        {propertyPhoto && (
          <div className="avatar">
            <img src={propertyPhoto} alt="property photo" />
          </div>
        )}
        <div className={`prop-wrapper${!propertyPhoto ? ' centered' : ''}`}>
          <span className="priceAverage">{formatCurrency(priceAverage)}</span>
          <span className="prop-specs">Estimated value for {street}</span>
          <div className="prop-specs">
            {propSpecs.map((spec, index) => (
              <span key={index} className={spec.split(' ')[1]}>
                {spec}
                {index !== propSpecs.length - 1 && <span className="dot-separator"> &middot; </span>}
              </span>
            ))}
          </div>
        </div>
      </div>
      {intention !== 'Curious' && (
        <div className="prop-details results bottom">
          <div className="whatsnext">
            <h1 className="title">What's next?</h1>
            {!kvCoreAgentInfo ? (
              <ul className="form-list">
                <li className="form-list__item">We're searching our database of 40,000+ agents and brokers</li>
                <li className="form-list__item">We'll match you with the perfect agent and <strong>connect you soon</strong></li>
              </ul>
            ) : (
              <p className="text-[rgb(42,47,100)]">Your agent will be reaching out to discuss your home valuation estimate.</p>
            )}
          </div>
          {kvCoreAgentInfo && (
            <div className="agent-info">
              <div className="w-96 p-4 border-[1px] border-[solid] border-[#F9ECE5] bg-[#F9ECE5] rounded-[30px] inline-flex flex-col justify-center items-center gap-2">
                {kvCoreAgentInfo.photo && (
                  <div
                    className="flex w-[74px] h-[74px] py-[25px] flex-col justify-end items-center gap-1 flex-shrink-0 rounded-[100px]"
                    style={{
                      backgroundImage: `url(${kvCoreAgentInfo.photo})`,
                      backgroundPosition: '50%',
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat'
                    }}
                  />
                )}
                <div className="flex flex-col items-center justify-center w-80">
                  <div className="flex flex-col items-center self-stretch justify-center gap-5">
                    <div className="flex flex-col items-start justify-start gap-4 overflow-hidden w-72">
                      <div className="w-72 rounded-[45px] flex flex-col justify-center items-center">
                        {kvCoreAgentInfo.name && (
                          <div className="justify-start text-2xl font-bold text-center text-slate-700">
                            {kvCoreAgentInfo.name}
                          </div>
                        )}
                        {kvCorePlatformName && (
                          <div className="flex flex-col items-center justify-start">
                            <span className="text-[#667085] font-[Poppins] text-[16px] not-italic font-normal leading-[150%]">
                              {kvCorePlatformName}
                            </span>
                          </div>
                        )}
                      </div>
                      {(kvCoreAgentInfo.email || kvCoreAgentInfo.phone) && (
                        <div className="self-stretch px-4 py-4 border-t border-stone-300 flex flex-col justify-center items-center gap-2.5">
                          {kvCoreAgentInfo.email && (
                            <div className="inline-flex items-center justify-start gap-2">
                              <div className="inline-flex flex-col items-center justify-center">
                                <div className="relative overflow-hidden">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                    <path d="M1.66602 6.07812L8.47012 10.841C9.02109 11.2267 9.29658 11.4195 9.59624 11.4942C9.86093 11.5602 10.1378 11.5602 10.4025 11.4942C10.7021 11.4195 10.9776 11.2267 11.5286 10.841L18.3327 6.07812M5.66602 16.9115H14.3327C15.7328 16.9115 16.4329 16.9115 16.9677 16.639C17.4381 16.3993 17.8205 16.0168 18.0602 15.5464C18.3327 15.0117 18.3327 14.3116 18.3327 12.9115V7.57813C18.3327 6.17799 18.3327 5.47793 18.0602 4.94315C17.8205 4.47274 17.4381 4.09029 16.9677 3.85061C16.4329 3.57812 15.7328 3.57812 14.3327 3.57812H5.66602C4.26588 3.57812 3.56582 3.57812 3.03104 3.85061C2.56063 4.09029 2.17818 4.47274 1.9385 4.94315C1.66602 5.47793 1.66602 6.17799 1.66602 7.57813V12.9115C1.66602 14.3116 1.66602 15.0117 1.9385 15.5464C2.17818 16.0168 2.56063 16.3993 3.03104 16.639C3.56582 16.9115 4.26588 16.9115 5.66602 16.9115Z" stroke="#6471ED" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                </div>
                              </div>
                              <div className="inline-flex flex-col items-start justify-start">
                                <span className="text-[#2A2F64] font-[Poppins] text-[14px] not-italic font-normal leading-[20px]">
                                  <a href={`mailto:${kvCoreAgentInfo.email}`}>{kvCoreAgentInfo.email}</a>
                                </span>
                              </div>
                            </div>
                          )}
                          {kvCoreAgentInfo.phone && (
                            <div className="pb-2.5 inline-flex justify-end items-center gap-2">
                              <div className="inline-flex flex-col items-center justify-center">
                                <div className="relative overflow-hidden">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M7.48356 7.62291C8.06356 8.83093 8.85422 9.96313 9.85553 10.9644C10.8568 11.9658 11.9891 12.7564 13.1971 13.3364C13.301 13.3863 13.3529 13.4112 13.4187 13.4304C13.6523 13.4985 13.9392 13.4496 14.137 13.3079C14.1927 13.2681 14.2403 13.2204 14.3356 13.1252C14.6269 12.8338 14.7726 12.6882 14.9191 12.5929C15.4715 12.2338 16.1837 12.2338 16.7361 12.5929C16.8825 12.6882 17.0282 12.8338 17.3196 13.1252L17.4819 13.2876C17.9248 13.7304 18.1462 13.9519 18.2665 14.1897C18.5058 14.6626 18.5058 15.2212 18.2665 15.6942C18.1462 15.932 17.9248 16.1534 17.4819 16.5963L17.3506 16.7276C16.9092 17.169 16.6886 17.3897 16.3885 17.5582C16.0556 17.7452 15.5385 17.8797 15.1567 17.8786C14.8126 17.8775 14.5774 17.8108 14.107 17.6773C11.5792 16.9598 9.19387 15.6061 7.20388 13.6161C5.2139 11.6261 3.86017 9.24081 3.1427 6.71298C3.00919 6.24261 2.94244 6.00742 2.94141 5.6633C2.94028 5.28145 3.07475 4.76437 3.26176 4.43145C3.4303 4.13142 3.65098 3.91075 4.09233 3.46939L4.22369 3.33803C4.66656 2.89516 4.888 2.67373 5.12581 2.55344C5.59878 2.31422 6.15734 2.31422 6.6303 2.55344C6.86812 2.67373 7.08955 2.89516 7.53242 3.33803L7.69481 3.50042C7.98615 3.79176 8.13182 3.93743 8.22706 4.08391C8.58622 4.63632 8.58622 5.34847 8.22706 5.90088C8.13182 6.04736 7.98615 6.19303 7.69481 6.48437C7.59955 6.57963 7.55192 6.62726 7.51206 6.68294C7.37038 6.8808 7.32146 7.16768 7.38957 7.40131C7.40873 7.46705 7.43367 7.519 7.48356 7.62291Z" stroke="#6471ED" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                </div>
                              </div>
                              <div className="inline-flex flex-col items-start justify-start">
                                <span className="text-[#2A2F64] font-[Poppins] text-[14px] not-italic font-normal leading-[20px]">
                                  <a href={`tel:${kvCoreAgentInfo.phone}`}>{formatPhoneNumber(kvCoreAgentInfo.phone)}</a>
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PropDetailsWithVal;
